export enum StatusType {
    UNRELEASED = 'UNRELEASED',
    RELEASED_WITHOUT_SCAN = 'RELEASED_WITHOUT_SCAN',
    RELEASED = 'RELEASED',
    INFECTED = 'INFECTED'
}